;(function() {
  'use strict'

  Controller.$inject = ["$sce", "$element", "$timeout", "acquiredPublicationsExporter", "surveyTransactionsExporter", "subscriberReportExporter", "creditTransactionsExporter", "surveyReportExporter", "channelReportExporter", "breadcrumbsService", "glAuthService", "configService"];
  angular.module('app.core').controller('SurveyBuilder', Controller)

  /* ngInject */
  function Controller(
    $sce,
    $element,
    $timeout,
    acquiredPublicationsExporter,
    surveyTransactionsExporter,
    subscriberReportExporter,
    creditTransactionsExporter,
    surveyReportExporter,
    channelReportExporter,
    breadcrumbsService,
    glAuthService,
    configService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.showAcquiredPublicationsExporter = acquiredPublicationsExporter.show
    ctrl.showSurveyTransactionsExporter = surveyTransactionsExporter.show
    ctrl.showSubscriberReportExporter = subscriberReportExporter.show
    ctrl.showCreditTransactionsExporter = creditTransactionsExporter.show
    ctrl.showSurveyReportExporter = surveyReportExporter.show
    ctrl.showChannelReportExporter = channelReportExporter.show

    var iframeOrigin = configService.getSurveyAiEditorOrigin()
    var dashboardURL = iframeOrigin + '/dashboard'

    function onInit() {
      breadcrumbsService.addBreadcrumb('AI Survey Builder', 'app.surveyBuilder')

      var authToken = glAuthService.getToken()

      ctrl.dashboardURL = $sce.trustAsResourceUrl(dashboardURL)

      // Wait for next digest cycle to ensure iframe is in DOM
      $timeout(function() {
        var iframe = $element[0].querySelector('iframe')
        if (iframe) {
          sendTokenToIframe(iframe, authToken)
        }
      })
    }

    function sendTokenToIframe(iframe, token) {
      var message = { type: 'AUTH_TOKEN', token: token }
      var targetOrigin = iframeOrigin

      function sendMessage() {
        console.log('[SurveyBuilder] Sending auth token to iframe')
        iframe.contentWindow.postMessage(message, targetOrigin)
      }

      // Always listen for load events (handles initial load + navigations)
      iframe.addEventListener('load', sendMessage)
    }
  }
})()
